import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Icon,
  Input,
  Row,
  TimePicker,
  DatePicker,
  Switch,
  Cascader,
  notification,
} from 'antd'
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {updateProduct, fetchProduct} from 'appRedux/actions/Product'

const FormItem = Form.Item

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

function TimeInfo(time, timeString) {
  console.log(time, timeString);
}

function DateInfo(date, dateString) {
  console.log(date, dateString);
}

class Basic extends React.Component {
  state = {
    visible: false,
    id: '',
    description: '',
    price: '',
    category_id: '',

    validateStatus: '',

    validateId: '',
    validateDescription: '',
    validatePrice: '',
    validateCategory: '',

    helpId: '',
    helpDescription: '',
    helpPrice: '',
    helpCategory: '',

    admin_id: '',
  }
  

  showModal = () => {
    this.setState({
      admin_id: this.props.recording.admin_id,
      visible: true,
      id: this.props.recording.id,
      description: this.props.recording.description,
      price: this.props.recording.price,
      category_id: this.props.recording.category_id,
    })
  }

  handleCancel = e => {
    this.setState({
      id: '',
      description: '',
      price: '',
      category_id: '',
    })

    this.props.fetchProduct()
    this.setState({visible: false})
    if (this.state.id == '') {
      this.setState({validateId: '', helpId: ''})
    }
    if (this.state.description == '') {
      this.setState({validateDescription: '', helpDescription: ''})
    }
    if (this.state.price == '') {
      this.setState({validatePrice: '', helpPrice: ''})
    }
    if (this.state.category_id == '') {
      this.setState({validateCategory: '', helpCategory: ''})
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: value || 'El producto se ha creado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al cambiar el producto.',
      })
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    let {id, description, price, category_id} = this.state
    if (this.state.validateStatus != 'error') {
      if (id && description && price && category_id != '') {
        this.props.updateProduct(this.state, () => {
          this.props.fetchProduct()
        })

        this.onNotification('success', 'El producto se ha editado con éxito')
      } else {
        if (this.state.id == '') {
          this.setState({
            validateId: 'error',
            helpId: 'Id es un campo obligatorio.',
          })
        } else {
          this.setState({validateId: '', helpId: ''})
        }
        if (this.state.description == '') {
          this.setState({
            validateDescription: 'error',
            helpDescription: 'Nombre es un campo obligatorio.',
          })
        } else {
          this.setState({validateDescription: '', helpDescription: ''})
        }
        if (this.state.price == '') {
          this.setState({
            validatePrice: 'error',
            helpPrice: 'Precio es un campo obligatorio.',
          })
        } else {
          this.setState({validatePrice: '', helpPrice: ''})
        }
        if (this.state.category_id == '') {
          this.setState({
            validateCategory: 'error',
            helpCategory: 'Categoria es un campo obligatorio.',
          })
        } else {
          this.setState({validateCategory: '', helpCategory: ''})
        }
        this.onNotification(
          'error',
          'Rellene los campos obligatorios',
        )
      }
    } 
  }



  render() {
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          <i className="icon icon-edit" />
        </Button>
        <Modal
          afterClose={() => this.props.fetchProduct()}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Editar pedido">
            <form onSubmit={this.onHandleClick}>
              <Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <FormItem
                    label="Fecha de entrega:"
                    labelCol={{xs: 11, sm: 11, lg: 11, md: 11}}
                    //validateStatus={this.state.validateDescription}
                    //help={this.state.helpDescription}
                  >
                    <DatePicker onChange={DateInfo} placeholder="Selecciona una fecha"/>
                    
                  </FormItem>
                </Col>

                <Col lg={24} md={24} sm={24} xs={24}>
                  <FormItem
                    label="Hora de entrega:"
                    labelCol={{xs: 11, sm: 11, lg: 11, md: 11}}
                    //validateStatus={this.state.validateDescription}
                    //help={this.state.helpDescription}
                  >
                     <TimePicker use12Hours format="h:mm a" onChange={TimeInfo} placeholder="Hora"/>
                    
                  </FormItem>
                </Col>

                <Col lg={24} md={24} sm={24} xs={24}>
                  <FormItem
                    label="Estado del pedido:"
                    labelCol={{xs: 11, sm: 11, lg: 11, md: 11}}
                    //validateStatus={this.state.validateDescription}
                    //help={this.state.helpDescription}
                  >
                     <Switch checkedChildren="Procesada" unCheckedChildren="No procesada" />
                    
                  </FormItem>
                </Col>
              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, products}) {
  return {
    placeStores,
    products,
  }
}
export default connect(
  mapStateToProps,
  {updateProduct, fetchProduct},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/verified/ModalEdit.js